module.exports = __webpack_public_path__ + "static/media/try-btn.6a2f6baf.png";